// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1OWa4","overflowing":"ReadFullNote_overflowing__E_63E"};